import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IUf } from '../types/IUf';

@Injectable({ providedIn: 'root' })
export class UfFilterState {
  private _ufs = new BehaviorSubject<IUf[] | null>(null);
  private _selectedUf = new BehaviorSubject<IUf | null>(null)

  setUfs(ufs: IUf[]) {
    this.ufs = ufs;
  }

  getUfs() {
    return this._ufs.getValue();
  }

  hasUfs() {
    return this._ufs.getValue() !== null;
  }

  observeUfs() {
    return this._ufs.asObservable();
  }

  setSelectedUf(uf: IUf) {
    this.selectedUf = uf;
  }

  selectByName(name: string) {
    if(this.hasUfs()) {
      this.selectedUf = this.getUfs().find(uf => uf.uf === name) || null;
    }
  }

  getSelectedUf() {
    return this._selectedUf.getValue();
  }

  hasSelectedUf() {
    return this._selectedUf.getValue() !== null;
  }

  observerSelectedUf() {
    return this._selectedUf.asObservable();
  }

  private set ufs(ufs: IUf[] | null) {
    this._ufs.next(ufs);
  }

  private set selectedUf(uf: IUf) {
    this._selectedUf.next(uf);
  }
}